module.exports = __webpack_public_path__ + "static/media/thum4.3fd17707.jpg";